import { upperFirst } from 'lodash'

import enumerationService from 'Services/EnumerationService'

// initial state
const state = {
  batchStatuses: [],
  beneficiaryStatuses: [],
  channels: [],
  countries: [],
  currencies: [],
  genders: [],
  orderLineTypes: [],
  paymentMethods: [],
  paymentStatuses: [],
  phoneNumberTypes: [],
  salutations: [],
  ticketPriorities: [],
  ticketStatuses: [],
  ticketTypes: []
}

const actions = {
  getEnumeration ({ commit }, { enumeration, parameters = null }) {
    return new Promise((resolve, reject) => {
      enumerationService[`get${upperFirst(enumeration)}`](parameters).then(result => {
        commit('setEnumerationProperty', { property: enumeration, value: result.data })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setEnumerationProperty (state, { property, value }) {
    state[property] = value
  }
}

export default {
  state,
  actions,
  mutations
}
